import { Capacitor } from '@capacitor/core';
import { Injectable, inject } from '@angular/core';
import { SavePinBase } from '../providers/save-pin-base/save-pin-base';
import { VaultFacade } from '../authentication/vault/vault.facade';

@Injectable({
  providedIn: 'root',
})
export class PinPersistentService extends SavePinBase {
  private readonly vaultService = inject(VaultFacade);
  private readonly isNativePlatform = Capacitor.isNativePlatform();

  public async getPin(username?: string): Promise<string | null> {
    if (!username) return Promise.resolve('');
    const storage = this.getPinStorage();
    return storage.get(username);
  }
  public async resetPin(username?: string): Promise<void> {
    if (!username) return Promise.resolve();
    const storage = this.getPinStorage();
    return storage.remove(username);
  }

  public async setPin(username: string, pin: string): Promise<void> {
    const storage = this.getPinStorage();
    return storage.set(username, pin);
  }

  private getPinStorage(): PinStorageAdapter {
    if (this.isNativePlatform) {
      return {
        get: (key: string) => this.vaultService.getValue<string>(key),
        set: (key: string, value: string) => this.vaultService.setValue<string>(key, value),
        remove: (key: string) => this.vaultService.removeValue(key),
      };
    } else {
      return {
        get: (key: string) => Promise.resolve(localStorage.getItem(key)),
        set: (key: string, value: string) => {
          localStorage.setItem(key, value);
          return Promise.resolve();
        },
        remove: (key: string) => {
          localStorage.removeItem(key);
          return Promise.resolve();
        },
      };
    }
  }
}

type PinStorageAdapter = {
  get: (key: string) => Promise<string | null>;
  set: (key: string, value: string) => Promise<void>;
  remove: (key: string) => Promise<void>;
};
